<template>
  <div>
    <DefaultPage id="financials">
      <div class="hero hero--purple">
        <div class="hero__call">
          <h1 class="hero__call__headline">
            Steady<span class="neplus orange-color">&amp;</span>Secure
          </h1>
          <h2 class="financials-headline-btm">for the future</h2>
        </div>
        <a :href="`${baseUrl}SVMIC 2021 Annual Report.pdf`"
            download="SVMIC 2021 Annual Report"
            class="download-btn">
          <div class="download-btn__icon">
            <div class="download-btn__icon__inner"></div>
          </div>
          <div class="download-btn__call">
            <p class="top">Download <br>the Print PDF</p>
          </div>
        </a>
        <!-- animated shapes -->
        <div class="triangle-fin-top-wrap">
          <div class="shape shape--hero triangle triangle--fin-top"></div>
        </div>
        <div class="dot-fin-top-wrap">
          <div class="shape shape--hero shape--has-bg dot dot--fin-top"></div>
        </div>
        <div class="shape shape--hero circle circle--fin-top-mid"></div>
        <div class="shape shape--hero circle circle--fin-top-blur"></div>
        <div class="shape shape--hero circle circle--fin-top-big"></div>
        <div class="shape shape--hero circle circle--fin-top-small"></div>
      </div>
      <ContentSection id="highlights"
                      title="Financial Highlights"
                      class="financial-section">
        <div class="grid-container">
          <div class="grid-x">
            <div class="cell" data-aos="fade-up">
              <div class="table-scroll">
                <table class="align-table-1">
                  <thead>
                  <tr>
                    <th><h4>At Year End</h4>
                    <p>($ in thousands)</p></th>
                    <th><h4>2017</h4></th>
                    <th><h4>2018</h4></th>
                    <th><h4>2019</h4></th>
                    <th><h4>2020</h4></th>
                    <th><h4>2021</h4></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>Cash and Invested Assets</td>
                    <td class="number">1,193,190</td>
                    <td class="number">1,208,752</td>
                    <td class="number">1,249,626</td>
                    <td class="number">1,294,540</td>
                    <td class="number">1,390,803</td>
                  </tr>
                  <tr>
                    <td>Total Assets</td>
                    <td class="number">1,249,290</td>
                    <td class="number">1,243,394</td>
                    <td class="number">1,278,382</td>
                    <td class="number">1,321,878</td>
                    <td class="number">1,415,225</td>
                  </tr>
                  <tr>
                    <td>Loss &amp; Loss Adjustment Expense Reserves</td>
                    <td class="number">472,500</td>
                    <td class="number">469,000</td>
                    <td class="number">455,000</td>
                    <td class="number">456,000</td>
                    <td class="number">468,500</td>
                  </tr>
                  <tr>
                    <td>Policyholders’ Surplus</td>
                    <td class="number">606,774</td>
                    <td class="number">623,955</td>
                    <td class="number">671,735</td>
                    <td class="number">705,694</td>
                    <td class="number">778,138</td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="separate-tables"><!--x--></div>
              <div class="table-scroll">
                <table class="align-table-1">
                  <thead>
                  <tr>
                    <th><h4>For The Year</h4>
                      <p>($ in thousands)</p></th>
                    <th><h4>2017</h4></th>
                    <th><h4>2018</h4></th>
                    <th><h4>2019</h4></th>
                    <th><h4>2020</h4></th>
                    <th><h4>2021</h4></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>Gross Written Premium</td>
                    <td class="number">125,844</td>
                    <td class="number">120,569</td>
                    <td class="number">119,235</td>
                    <td class="number">113,815</td>
                    <td class="number">121,824</td>
                  </tr>
                  <tr>
                    <td>Net Investment Income</td>
                    <td class="number">27,454</td>
                    <td class="number">32,557</td>
                    <td class="number">29,829</td>
                    <td class="number">28,148</td>
                    <td class="number">26,398</td>
                  </tr>
                  <tr>
                    <td>Net Paid Loss &amp; Loss Adjustment Expenses</td>
                    <td class="number">100,002</td>
                    <td class="number">92,522</td>
                    <td class="number">99,472</td>
                    <td class="number">80,225</td>
                    <td class="number">72,699</td>
                  </tr>
                  <tr>
                    <td>Policyholders’ Dividends Declared</td>
                    <td class="number">7,000</td>
                    <td class="number">7,000</td>
                    <td class="number">7,000</td>
                    <td class="number">7,000</td>
                    <td class="number">7,000</td>
                  </tr>
                  <tr>
                    <td>Net Income</td>
                    <td class="number">29,646</td>
                    <td class="number">28,542</td>
                    <td class="number">22,074</td>
                    <td class="number">23,853</td>
                    <td class="number">17,077</td>
                  </tr>
                  <tr>
                    <td>Cumulative Dividends and Return of Capital</td>
                    <td class="number">356,500</td>
                    <td class="number">363,500</td>
                    <td class="number">370,500</td>
                    <td class="number">377,500</td>
                    <td class="number">384,500</td>
                  </tr>
                  <tr>
                    <td>Outstanding Mutual Value Plan Balances</td>
                    <td class="number">-</td>
                    <td class="number">68,538</td>
                    <td class="number">82,272</td>
                    <td class="number">87,463</td>
                    <td class="number">94,376</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </ContentSection>
      <ContentSection id="balance-sheets"
                      title="Condensed Balance Sheets"
                      subtext="(as of December 31, 2021 &amp; 2020)"
                      class="financial-section">
        <div class="grid-container">
          <div class="grid-x">
            <div class="cell" data-aos="fade-up">
              <div class="table-scroll">
                <table class="align-table-2 right-aligned">
                  <thead>
                  <tr>
                    <th><h4>Assets</h4></th>
                    <th><h4>2021</h4></th>
                    <th><h4>2020</h4></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>Cash &amp; Investments</td>
                    <td class="number">1,390,803,000</td>
                    <td class="number">1,294,540,000</td>
                  </tr>
                  <tr>
                    <td>Premiums Receivable</td>
                    <td class="number">14,628,000</td>
                    <td class="number">13,545,000</td>
                  </tr>
                  <tr>
                    <td>Accrued Investment Income</td>
                    <td class="number">7,845,000</td>
                    <td class="number">8,540,000</td>
                  </tr>
                  <tr>
                    <td>Reinsurance Recoverable</td>
                    <td class="number">1,547,000</td>
                    <td class="number">4,484,000</td>
                  </tr>
                  <tr>
                    <td>Federal Income Taxes Recoverable</td>
                    <td class="number">207,000</td>
                    <td class="number">439,000</td>
                  </tr>
                  <tr>
                    <td class="bb">Other Assets</td>
                    <td class="bb number">195,000</td>
                    <td class="bb number">330,000</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr>
                    <th>Total Assets</th>
                    <th class="number">$1,415,225,000</th>
                    <th class="number">$1,321,878,000</th>
                  </tr>
                  </tfoot>
                </table>
              </div>
              <div class="separate-tables"><!--x--></div>
              <div class="table-scroll">
                <table class="align-table-2 right-aligned">
                  <thead>
                  <tr>
                    <th>
                      <h4>Liabilities &amp; Policyholders’ Surplus</h4>
                      <p>Liabilities</p>
                    </th>
                    <th><h4>2021</h4></th>
                    <th><h4>2020</h4></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>Loss &amp; Loss Adjustment Expense Reserves</td>
                    <td class="number">468,500,000</td>
                    <td class="number">456,000,000</td>
                  </tr>
                  <tr>
                    <td>Unearned Premiums</td>
                    <td class="number">65,862,000</td>
                    <td class="number">63,084,000</td>
                  </tr>
                  <tr>
                    <td>Reinsurance Balances Payable</td>
                    <td class="number">19,260,000</td>
                    <td class="number">21,686,000</td>
                  </tr>
                  <tr>
                    <td>Accounts Payable and Accrued Expenses</td>
                    <td class="number">58,343,000</td>
                    <td class="number">63,529,000</td>
                  </tr>
                  <tr>
                    <td>Net Deferred Tax Liabilities</td>
                    <td class="number">17,393,000</td>
                    <td class="number">3,786,000</td>
                  </tr>
                  <tr>
                    <td>Dividends Payable</td>
                    <td class="number">2,714,000</td>
                    <td class="number">2,696,000</td>
                  </tr>
                  <tr>
                    <td class="bb">Other Liabilities</td>
                    <td class="bb number">5,015,000</td>
                    <td class="bb number">5,403,000</td>
                  </tr>
                  <tr>
                    <th>Total Liabilities</th>
                    <th class="number">$637,087,000</th>
                    <th class="number">$616,184,000</th>
                  </tr>
                  </tbody>
                </table>
                <br>
                <table class="align-table-2 right-aligned">
                  <tbody>
                  <tr>
                    <th><p class="sub-title-financial">Policyholders’ Surplus</p></th>
                  </tr>
                  <tr>
                    <td>Expected Mutual Value Plan Obligation</td>
                    <td class="number">32,058,000</td>
                    <td class="number">29,121,000</td>
                  </tr>
                  <tr>
                    <td class="bb">Unassigned Surplus</td>
                    <td class="bb number">746,080,000</td>
                    <td class="bb number">676,573,000</td>
                  </tr>
                  <tr>
                    <th style="font-weight: 600;" class="bb">Total Policyholders’ Surplus</th>
                    <th style="font-weight: 600;" class="bb number">$778,138,000</th>
                    <th style="font-weight: 600;" class="bb number">$705,694,000</th>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr>
                    <th>Total Liabilities &amp; Policyholders’ Surplus</th>
                    <th class="number">$1,415,225,000</th>
                    <th class="number">$1,321,878,000</th>
                  </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
      </ContentSection>
      <ContentSection id="statements-of-income"
                      title="Condensed Statements of Income"
                      subtext="(For the years ended December 31, 2021 &amp; 2020)"
                      class="financial-section">
        <div class="grid-container">
          <div class="grid-x">
            <div class="cell" data-aos="fade-up">
              <div class="table-scroll">
                <table class="align-table-2 right-aligned">
                  <thead>
                    <tr>
                      <th><h4>&nbsp;</h4></th>
                      <th><h4>2021</h4></th>
                      <th><h4>2020</h4></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Gross Written Premium</td>
                      <td class="number">121,824,000</td>
                      <td class="number">113,815,000</td>
                    </tr>
                    <tr>
                      <td>Ceded Premium</td>
                      <td class="number">(11,934,000)</td>
                      <td class="number">(11,537,000)</td>
                    </tr>
                    <tr style="border-top: 1px solid black !important;">
                      <td>Net Written Premium</td>
                      <th class="number">$109,890,000</th>
                      <th class="number">$102,278,000</th>
                    </tr>
                    <tr>
                      <td>Change in Unearned Premium</td>
                      <td class="number">(2,777,000)</td>
                      <td class="number">742,000</td>
                    </tr>
                    <tr style="border-top: 1px solid black !important;">
                      <td>Net Earned Premium</td>
                      <th class="number no-extra-padding">$107,113,000</th>
                      <th class="number no-extra-padding">$103,020,000</th>
                    </tr>
                    <tr class="spacer-row"></tr>
                    <tr>
                      <td>Loss &amp; Loss Adjustment Expenses Incurred</td>
                      <td class="number">85,199,000</td>
                      <td class="number">81,225,000</td>
                    </tr>
                    <tr>
                      <td>Other Underwriting Expenses</td>
                      <td class="number">23,892,000</td>
                      <td class="number">23,816,000</td>
                    </tr>
                    </tbody>
                    <tbody class="bl-border">
                    <tr>
                      <td>Net Underwriting Income</td>
                      <th class="number">($1,978,000)</th>
                      <th class="number">($2,021,000)</th>
                    </tr>
                    <tr class="spacer-row"></tr>
                    <tr>
                      <td>Net Investment Income</td>
                      <td class="number">26,398,000</td>
                      <td class="number">28,148,000</td>
                    </tr>
                    <tr>
                      <td>Net Realized Capital Gains (Losses) on Investments</td>
                      <td class="number">2,588,000</td>
                      <td class="number">7,912,000</td>
                    </tr>
                  </tbody>
                  <tbody class="bl-border">
                    <tr>
                      <td>Net Investment Gains</td>
                      <th class="number">$28,986,000</th>
                      <th class="number">$36,060,000</th>
                    </tr>
                    <tr class="spacer-row"></tr>
                  </tbody>
                  <tbody>
                    <tr style="border-bottom: 1px solid black !important; background-color: white !important;">
                      <td style="padding-top: 15px;">Other Income (Expense)</td>
                      <td style="padding-top: 15px;" class="number">(3,000)</td>
                      <td style="padding-top: 15px;" class="number">(204,000)</td>
                    </tr>
                    <tr class="spacer-row"></tr>
                    <tr>
                      <td>Net Income Before Taxes and Policyholders’ Dividends</td>
                      <td class="number bold">$27,005,000</td>
                      <td class="number bold">$33,835,000</td>
                    </tr>
                    <tr>
                      <td class="bb">Policyholders’ Dividends &amp; Federal Income Taxes Incurred</td>
                      <td class="bb number">(9,928,000)</td>
                      <td class="bb number">(9,982,000)</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td>Net Income</td>
                      <td class="number">$17,077,000</td>
                      <td class="number">$23,853,000</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
          <div class="grid-x">
            <div class="cell large-7 medium-9">
              <p class="note">Note: The financial statements have been prepared in conformity with accounting practices
                prescribed or permitted by the Tennessee Department of Commerce and Insurance. The condensed financial
                information has been derived from the complete statutory-basis financial statements which were audited
                by Ernst &amp; Young LLP, our independent auditors. A complete set of audited financial statements is
                available upon request.</p>
            </div>
          </div>
        </div>
      </ContentSection>
      <ContentSection id="mvp-allocations"
                      title="MVP Allocations">
        <div class="grid-container">
          <div class="grid-x">
            <div class="cell" data-aos="fade-up">
              <div class="table-scroll">
                <table class="align-table-1">
                  <thead>
                  <tr>
                    <th><h4>Cumulative Allocations</h4></th>
                    <th><h4>Q1</h4></th>
                    <th><h4>Q2</h4></th>
                    <th><h4>Q3</h4></th>
                    <th><h4>Q4</h4></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>2018</td>
                    <td class="number">--</td>
                    <td class="number">--</td>
                    <td class="number">$56,297,395</td>
                    <td class="number">$68,916,748</td>
                  </tr>
                  <tr>
                    <td>2019</td>
                    <td class="number">$74,853,671</td>
                    <td class="number">$78,076,027</td>
                    <td class="number">$83,968,112</td>
                    <td class="number">$87,142,761</td>
                  </tr>
                  <tr>
                    <td>2020</td>
                    <td class="number">$90,943,386</td>
                    <td class="number">$93,036,476</td>
                    <td class="number">$96,015,035</td>
                    <td class="number">$97,918,479</td>
                  </tr>
                  <tr>
                    <td>2021</td>
                    <td class="number">$101,791,254</td>
                    <td class="number">$104,252,978</td>
                    <td class="number">$108,394,305</td>
                    <td class="number">$110,887,815</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </ContentSection>
      <ContentSection id="policyholders-surplus"
                      title="Policyholders' Surplus / Total Assets"
                      class="financial-section">
        <div class="grid-container">
          <div class="chart-label-container"
               data-aos="fade-down">
            <div class="grid-x">
              <div class="large-3 small-6">
                <div class="chart-label">
                  <div class="dot label2">
                  </div>
                  <p>Policyholders’ Surplus</p>
                </div>
              </div>
              <div class="large-3 small-6">
                <div class="chart-label">
                  <div class="dot label1">
                  </div>
                  <p>Total Assets</p>
                </div>
              </div>
            </div>
          </div>
          <ChartContainer chartClass="chart-container-policyholders-surplus">
            <PolicyholdersSurplusChart/>
          </ChartContainer>
        </div>
      </ContentSection>
      <ContentSection id="cumulative-dividends"
                      title="Cumulative Dividends Declared &amp; Return of Capital">
        <div class="grid-container">
          <ChartContainer chartClass="chart-container-cumulative-dividends">
            <CumulativeDividendsChart/>
          </ChartContainer>
        </div>
      </ContentSection>
      <ContentSection id="premiums-per-physician"
                      title="Premiums Per Physician">
        <div class="grid-container">
          <div class="chart-label-container"
               data-aos="fade-down">
            <div class="grid-x">
              <div class="large-4 small-6">
                <div class="chart-label">
                  <div class="dot label4">
                  </div>
                  <p>Average Premium Per Physician</p>
                </div>
              </div>
              <div class="large-4 small-6">
                <div class="chart-label">
                  <div class="dot label3">
                  </div>
                  <p>Average Premium Per Physician</p>
                  <p class="sub-label">(in today's dollars)</p>
                </div>
              </div>
            </div>
          </div>
          <ChartContainer chartClass="chart-container-premiums-per-physician">
            <PremiumsPerPhysicianChart/>
          </ChartContainer>
        </div>
      </ContentSection>
    </DefaultPage>
  </div>
</template>

<script>
import DefaultPage from '@/layouts/DefaultPage';
import ContentSection from '@/components/section/VisualDataSection';
import PolicyholdersSurplusChart from '@/components/chart/PolicyholdersSurplusChart';
import ChartContainer from '@/components/chart/ChartContainer';
import CumulativeDividendsChart from '@/components/chart/CumulativeDividendsChart';
import PremiumsPerPhysicianChart from '@/components/chart/PremiumsPerPhysicianChart';

export default {
  name: 'Financials',
  components: {
    PremiumsPerPhysicianChart,
    CumulativeDividendsChart,
    ChartContainer,
    PolicyholdersSurplusChart,
    ContentSection,
    DefaultPage
  },
  data () {
    return {
      baseUrl: process.env.BASE_URL
    };
  }
};
</script>
